import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ListExpenseType from '../../../components/MasterData/ExpenseType/list'
import constant from '../../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_expenseTypes, v3_expenseType_visibility } from '../../../actions/v3/masterData'
import { replacePageState } from '../../../utils';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        v3_expenseTypes(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listExpenseTypeMasterData.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    const onChangeVisibility = (record) => {
        const newStatus = record.IS_ACTIVE ? false : true; // Toggle visibility

        v3_expenseType_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    expenseTypes: prevState.expenseTypes.map(item =>
                        item.ID === record.ID
                            ? { ...item, IS_ACTIVE: newStatus }
                            : item
                    )
                }));
                toast.success(res.result.message);
            } else {
                toast.error("Failed to update status");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating visibility");
        });
    };



    return (
        <Layout
            title={'Expense Type List'}
        >
            {data && <ListExpenseType
                onChangeVisibility={onChangeVisibility}
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List